module.exports = __webpack_public_path__ + "assets/img/report-bottom-bg.82f2d589.png";